import React from 'react';

const StatCardHorizontal = ({ 
  title, 
  value, 
  subtitle,
  icon,
  color = 'amber',
  onClick 
}) => {
  const colorClasses = {
    amber: 'bg-amber-100 border-amber-200',
    red: 'bg-red-100 border-red-200',
    orange: 'bg-orange-100 border-orange-200',
    blue: 'bg-blue-100 border-blue-200',
    green: 'bg-green-100 border-green-200',
    teal: 'bg-teal-100 border-teal-200',
    purple: 'bg-purple-100 border-purple-200',
    yellow: 'bg-yellow-100 border-yellow-200',
    rose: 'bg-rose-100 border-rose-200',
    indigo: 'bg-indigo-100 border-indigo-200',
    lime: 'bg-lime-100 border-lime-200',
  };

  const iconBgClasses = {
    amber: 'bg-amber-300',
    red: 'bg-red-300',
    orange: 'bg-orange-300',
    blue: 'bg-blue-300',
    green: 'bg-green-300',
    teal: 'bg-teal-300',
    purple: 'bg-purple-300',
    yellow: 'bg-yellow-300',
    rose: 'bg-rose-300',
    indigo: 'bg-indigo-300',
    lime: 'bg-lime-300',
  };

  return (
    <div 
      onClick={onClick}
      className={`${colorClasses[color]} border rounded-xl p-3 flex items-center gap-3 ${onClick ? 'cursor-pointer hover:shadow-md transition-shadow' : ''}`}
      data-testid={`stat-${title.toLowerCase().replace(/\s+/g, '-')}`}
    >
      {icon && (
        <div className={`${iconBgClasses[color]} w-10 h-10 rounded-full flex items-center justify-center text-xl shrink-0`}>
          {icon}
        </div>
      )}
      <div className="min-w-0">
        <div className="flex items-baseline gap-2">
          <span className="text-2xl font-bold text-black">{value}</span>
        </div>
        <div className="text-xs text-stone-600 font-medium truncate">{title}</div>
        {subtitle && (
          <div className="text-xs text-stone-500 truncate">{subtitle}</div>
        )}
      </div>
    </div>
  );
};

export default StatCardHorizontal;
